import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import toastMessages from "src/constant/toastMessages.json";
import { ChangePassword } from "src/thunks/auth";
import { GetError } from "src/constant";
import { AuthenticationWrawper } from "src/components/AuthenticationWrawper";
import { resetPasswordValidationScehma } from "src/helpers/yup_schema";

const Login = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { verifyToken } = useSelector((state) => state.auth);

  /** hooks useState ----------------------------------------------------- **/
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");

  /** react hook form declaration ------------------------------ **/
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors: errorsResetPwd },
  } = useForm({
    resolver: yupResolver(resetPasswordValidationScehma),
  });

  /** Variable declarations ----------------------------------------------------- **/
  const pwdFieldvalue = watch("password", "");
  const confirmPwdFieldvalue = watch("confirmPassword", "");
  const confirmPwdFormButtonClassName = confirmPwdFieldvalue !== "" && confirmPwdFieldvalue == pwdFieldvalue ? "email-form-enabled-button" : "email-form-disabled-button";

  /** handler functions--------------------------------------------------- **/

  /** Function executes when reset password ---------------- **/
  const onResetPasswordSubmitHandler = async (data) => {
    try {
      const res = await dispatch(
        ChangePassword({
          token: verifyToken,
          email: localStorage.getItem("email"),
          password: data?.password,
        })
      ).unwrap();
      if (res) {
        toast.success(toastMessages.pwdReset);
        navigate("/successresetpassword");
        localStorage.removeItem("email");
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  /** Function executes when toggle password field -------------- **/
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  /** Function to navigate back to the login screen --------------- **/
  const handleCancelButtonClickFromResetPwd = () => {
    navigate("/login");
  };

  /** Function executes when toggle confirm password field  */
  const toggleConfirmPassword = () => {
    if (confirmPasswordType === "password") {
      setConfirmPasswordType("text");
      return;
    }
    setConfirmPasswordType("password");
  };


  return (
    <>
      <AuthenticationWrawper>
        <div className="reset-pwd-text-style">Reset Your password</div>
        <div style={{ marginTop: 13, width: "85%" }}>
          <form
            className="login-form-main-class"
            onSubmit={handleSubmit(onResetPasswordSubmitHandler)}
          >
            <div className="form-floating" style={{ position: "relative" }}>
              <TextField
                className="depot-form-textfields-style"
                type={passwordType}
                {...register("password")}
                id="standard-basic"
                label="Password"
                variant="standard"
              />
            </div>
            <div
              style={{
                position: "absolute",
                right: 28,
                top: 90,
                cursor: "pointer",
              }}
            >
              {passwordType === "password" ? (
                <i
                  className="bi bi-eye-slash-fill"
                  onClick={togglePassword}
                ></i>
              ) : (
                <i className="bi bi-eye-fill" onClick={togglePassword}></i>
              )}
            </div>
            <div
              className="form-errors d-flex justify-content-start mt-2 email-not-registered-error"
              style={{
                height: 20,
              }}
            >
              {errorsResetPwd.password?.message && (
                <i className="bi bi-exclamation-circle-fill me-1"></i>
              )}
              <p> {errorsResetPwd.password?.message}</p>{" "}
            </div>

            <div
              className="form-floating"
              style={{ position: "relative", marginTop: 35 }}
            >
              <TextField
                className="depot-form-textfields-style"
                {...register("confirmPassword")}
                type={confirmPasswordType}
                id="standard-basic"
                label="Confirm Password"
                variant="standard"
              />
            </div>
            <div
              style={{
                position: "absolute",
                right: 28,
                top: 165,
                cursor: "pointer",
                marginTop: 35,
              }}
            >
              {confirmPasswordType === "password" ? (
                <i
                  className="bi bi-eye-slash-fill"
                  onClick={toggleConfirmPassword}
                ></i>
              ) : (
                <i
                  className="bi bi-eye-fill"
                  onClick={toggleConfirmPassword}
                ></i>
              )}
            </div>
            <div
              className="form-errors d-flex justify-content-start mt-2 email-not-registered-error"
              style={{
                height: 20,
              }}
            >
              {errorsResetPwd.confirmPassword?.message && (
                <i className="bi bi-exclamation-circle-fill me-1"></i>
              )}
              <p> {errorsResetPwd.confirmPassword?.message}</p>
            </div>
            <div
              className="d-flex flex-row justify-content-between "
              style={{
                marginTop: 10,
                height: 70,
                paddingTop: 12,
                marginBottom: -10,
              }}
            >
              <div
                className="d-flex flex-column"
                style={{ position: "absolute", left: -8 }}
              >
                <button
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    fontSize: 12,
                    fontFamily: "Montserrat-bold",
                    backgroundColor: "#e94f37",
                    color: "#FFFFFF",
                    height: 30,
                    width: 110,
                    marginRight: "-8px",
                    border: "none",
                    boxShadow: "3px 3px darkgrey",

                  }}
                  onClick={handleCancelButtonClickFromResetPwd}
                // type="submit"
                >
                  <i
                    className="bi bi-arrow-left-short"
                    style={{ fontSize: 20 }}
                  ></i>
                  CANCEL
                </button>
                <div className="d-flex justify-content-start">
                  <i className="bi bi-caret-right-fill fold-back-button-styling"></i>
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{ position: "absolute", right: 0 }}
              >
                <button
                  disabled={
                    confirmPwdFieldvalue !== "" &&
                      confirmPwdFieldvalue == pwdFieldvalue
                      ? false
                      : true
                  }
                  className={`${confirmPwdFormButtonClassName} d-flex justify-content-center align-items-center`}
                  style={{
                    fontSize: 12,
                    fontFamily: "Montserrat-bold",
                    height: 30,
                    width: 110,
                    marginRight: "-8px",
                    border: "none",
                    boxShadow: "3px 3px darkgrey",
                  }}
                  type="submit"
                >
                  CONFIRM
                  <i
                    className="bi bi-check-lg arrow-size-for-login"
                    style={{ fontSize: 20 }}
                  ></i>
                </button>
                <div className="d-flex justify-content-end">
                  <i className="bi bi-caret-right-fill fold-button-styling"></i>
                </div>
              </div>
            </div>
            <div></div>
          </form>
        </div>
      </AuthenticationWrawper>
    </>
  );
};

export default Login;
